import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@material-ui/lab";
import "styled-components/macro";
import { theme } from "config/theme";
import { EventItem } from "components/EventItem";
import { UserCreatedBy } from "generated/graphql";

export interface Colors {
  text: string;
  background: string;
  border: string;
}
export interface EventsProps {
  status: string;
  username: string;
  description: string;
  userColor?: string;
  userTextColor?: string;
  statusColor?: string;
  statusTextColor?: string;
  date?: string;
  time?: string;
  timeLineColor?: string;
  height?: number;
  width?: number;
  user?: UserCreatedBy | null;
  signature?: string,
  color?:Colors
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      marginLeft: -15
    },
    dateTime: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
    },
    date: {
      fontFamily: "Avenir",
      fontSize: 14,
      lineHeight: 1.36,
      textAlign: "center",
      color: "#707070",
      flex: 1,
      marginRight: "auto",
    },
    time: {
      fontFamily: "Avenir",
      fontSize: 11,
      fontWeight: 300,
      fontStyle: "oblique",
      lineHeight: 1.36,
      textAlign: "center",
      color: "#707070",
      marginRight: "auto",
    },
  })
);

export function Events({
  status,
  username,
  description,
  date,
  time,
  timeLineColor,
  user = null,
  signature,
  color
}: EventsProps) {
  const styles = useStyles();
  return (
    <>
      <Timeline className={styles.root}>
        <TimelineItem>
          <TimelineOppositeContent
            css={`
              padding-left: 0;
            `}
          >
            <div className={styles.dateTime}>
              <div className={styles.date}>{date} </div>
              <div className={styles.time}>{time}</div>
            </div>
          </TimelineOppositeContent>
          <TimelineSeparator>
            <TimelineDot
              css={`
                background-color: ${timeLineColor};
              `}
            />
            <TimelineConnector
              css={`
                background-color: ${timeLineColor};
              `}
            />
          </TimelineSeparator>
          <TimelineContent
            css={`
              padding-right: 0;
              padding-left: ${theme.spacing(1)}px;
              flex-basis: 65%;
            `}
          >
            <EventItem
              {...{ signature }}
              description={description}
              username={username}
              status={status}
              statusTextColor="#fff"
              user={user}
              color={color}
            />
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </>
  );
}

export default Events;
